import { useContext } from "react";

import { useAsyncCall } from "hooks";

import {
  HubContext,
  ToasterContext,
} from "scenes/Hubly/components/Workspace/Provider";

import { isSequentialReminder } from "../components/Task/components/TaskFutureReminder/helper";
import {
  useAssignTaskToConditionsGroupAction,
  useRemoveTaskFromConditionsGroup,
} from ".";

export function useTaskOrderAction() {
  const [call, running] = useAsyncCall();
  const { fireError, fireWarning } = useContext(ToasterContext);
  const { reOrderTask, convertTaskToFutureReminder } = useContext(HubContext);

  const assignTaskToConditionsGroup = useAssignTaskToConditionsGroupAction();
  const removeTaskFromConditionsGroup = useRemoveTaskFromConditionsGroup();

  const reOrderAndConvertTask = async (orderedTasks) => {
    try {
      await reOrderTask({ items: orderedTasks });

      if (isSequentialReminder(orderedTasks[0])) {
        await convertTaskToFutureReminder(orderedTasks[0]);
        fireWarning(
          "The first task cannot be a sequential reminder, it has been converted to a future reminder."
        );
      }
      return true;
    } catch (error) {
      const { response: { data = {} } = {} } = error;

      fireError(data?.message || "Failed to reorder task", error);
      return false;
    }
  };

  return {
    running: running,
    reOrderTask: ({ orderedItems, target }, original) => {
      return call(async () => {
        await reOrderAndConvertTask(orderedItems);
      });
    },
    assignTaskToConditionsGroup: (
      { orderedItems, target, targetGroup },
      originalTasks
    ) => {
      return call(async () => {
        if (!(await reOrderAndConvertTask(orderedItems))) return;
        if (await assignTaskToConditionsGroup(target.id, targetGroup.id))
          return;

        await reOrderTask({ items: originalTasks });
      });
    },
    removeTaskFromConditionsGroup: (
      { orderedItems, target },
      originalTasks
    ) => {
      return call(async () => {
        if (!(await removeTaskFromConditionsGroup(target.id))) return;
        if (await reOrderAndConvertTask(orderedItems)) return;

        await reOrderTask({ items: originalTasks });
      });
    },
  };
}

export default useTaskOrderAction;
